// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-modal-edit-discovery-selector-3fc54 .edit-modal-namespace-label-78604 .ant-form-item-label-left{margin-right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edit-discovery-selector": "edit-modal-edit-discovery-selector-3fc54",
	"editDiscoverySelector": "edit-modal-edit-discovery-selector-3fc54",
	"namespace-label": "edit-modal-namespace-label-78604",
	"namespaceLabel": "edit-modal-namespace-label-78604"
};
export default ___CSS_LOADER_EXPORT___;
